import React from "react";
import "./resumeBtn.css";

const ResumeBtn = () => {
    return (
      <button className="resumeBtn">
      Get Resume
     </button>
    )
}

export default ResumeBtn